<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <AnimatedContainer v-if="filteredBreadcrumbs && (!withCurrentPage || filteredBreadcrumbs.length > 1)" :ready="ready">
    <ul
      ref="element"
      class="hide-scrollbar my-8 flex max-w-full items-center overflow-x-auto text-sm text-grey-300"
    >
      <li
        v-for="(crumb, index) in filteredBreadcrumbs"
        :key="crumb.url"
        class="flex items-center slide-left"
      >
        <!-- CRUMBS -->
        <div v-if="index === 0" class="mr-2">
          <NuxtLink :to="crumb.url">
            <IconHouse class="w-[1.2em] transition-colors hover:text-secondary-900" />
          </NuxtLink>
        </div>
        <Component
          :is="NuxtLinkOrSpan(crumb)"
          v-else
          class="mt-0.5 flex shrink-0 items-center whitespace-nowrap"
          :to="crumb.url"
          :class="NuxtLinkOrSpan(crumb) !== 'span' ? 'transition-colors hover:text-secondary-900': ''"
          :aria-label="crumb.title"
        >
          {{ crumb.title }}
        </Component>

        <!-- PIPE -->
        <span
          v-if="index > 0 && index < filteredBreadcrumbs.length - 1"
          class="relative mx-[0.1em] shrink-0"
        >
          <IconChevron class="h-[1em] -rotate-90" />
        </span>
      </li>
    </ul>
  </AnimatedContainer>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const props = defineProps({
  withCurrentPage: {
    type: Boolean,
    default: false,
  },

  breadcrumbs: {
    type: Array,
    default: () => [],
  },
})

const route = useRoute()

const entry = inject(EntryInjectionKey, null)

const ready = ref(false)

const element = ref(null)

const filteredBreadcrumbs = computed(() => {
  const breadcrumbs = entry.value?.breadcrumbs || entry.value?.BreadcrumbsFromStructure || props.breadcrumbs || []

  if (props.withCurrentPage) {
    return breadcrumbs
  }

  // Filter out the current page from the breadcrumbs
  return breadcrumbs?.filter(crumb => crumb.url !== route.path) || []
})

// Ued for the back link which is currently not used
const nextParentCrumb = computed(() => {
  let index = filteredBreadcrumbs.value.length - 1

  if (props.withCurrentPage) {
    index = filteredBreadcrumbs.value.length - 2
  }

  if (index < 0) {
    return 0
  }

  return filteredBreadcrumbs.value[index]
})

// determine whether to load AppLink or span
function NuxtLinkOrSpan(crumb) {
  if (crumb.url && route.path !== crumb.url && crumb.entry?.published) {
    return resolveComponent('NuxtLink')
  }

  return 'span'
}

onMounted(async () => {
  await nextTick()

  setScrollPosition()

  await new Promise(resolve => setTimeout(resolve, 500))

  ready.value = true
})

function isOverflowing() {
  return element.value?.scrollWidth >= element.value?.clientWidth
}

async function setScrollPosition() {
  if (isOverflowing()) {
    await new Promise(resolve => setTimeout(resolve, 500))

    element.value.scrollLeft = element.value.scrollWidth
  }
}
</script>
